<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

nav {
    font-size: 1rem;
    letter-spacing: .2rem;
    font-weight: 100;
    background-color: rgba(0, 0, 0, 0.75);
}

.sixHome {
    background: url('/images/home/logo-nav.png');
    background-size: 60px;
    background-repeat: no-repeat;
    width: 60px;
    height: 60px;
    text-indent: -9999px;
    margin-top: -5px;
}

.sixHomeMobile {
    background: url('/images/home/logo-nav.png');
    background-size: 60px;
    background-repeat: no-repeat;
    margin: auto;
    width: 60px;
    height: 60px;
    text-indent: -9999px;
    margin-top: 50px;
}

.navItem {
    width: 210px;
    padding: 0 1rem;
    margin-top: -10px;
    margin-bottom: 10px;
}

.mobile-logo {
    text-align: center;
    position: fixed;
    top: 20px;
    left: 0;
    z-index: 15;
    width: 100%;
}

.mobile-logo img {
    width: 50px;
    display: inline;
}

.mobile-menu {
    position: fixed;
    top: 0;
    z-index: 16;
    width: 100%;
    background: black;
}

.menu-icon {
    position: fixed;
    top: 40px;
    left: 20px;
    z-index: 30;
}

.menu-icon .menu-svg {
    fill: #FFFFFF;
}

</style>

<template>

<nav class="block w-full text-white xl:flex-grow-0 xl:fixed z-10 xl:pt-5">
    <ul class="hidden xl:flex w-full justify-between" @click="handleclick">

        <NavBarLink to="/gallery" name="GALLERY" class="navItem" />
        <NavBarLink to="/stack-plan" name="STACK PLAN" class="navItem" />
        <NavBarLink to="/floor-plan" name="FLOOR PLANS" class="navItem" />

        <NavBarLink to="/" name="Six" class="sixHome" />

        <NavBarLink to="/amenities" name="AMENITIES" class="navItem" />
        <NavBarLink to="/neighborhood" name="NEIGHBORHOOD" class="navItem" />
        <NavBarLink to="/inquiries" name="INQUIRIES" class="navItem" />
    </ul>


  <transition name="fade">
    <ul v-if="menuIsOpen" class="block xl:hidden mobile-menu" @click="handleclick">

            <NavBarLink to="/gallery" name="GALLERY" class="navItemMobile" />
            <NavBarLink to="/stack-plan" name="STACK PLAN" class="navItemMobile" />
            <NavBarLink to="/floor-plan" name="FLOOR PLANS" class="navItemMobile" />
            <NavBarLink to="/amenities" name="AMENITIES" class="navItemMobile" />
            <NavBarLink to="/neighborhood" name="NEIGHBORHOOD" class="navItemMobile" />
            <NavBarLink to="/inquiries" name="INQUIRIES" class="navItemMobile" />

    </ul>
      </transition>
    <div class="mobile-logo block xl:hidden">
        <a href="/"><img src="/images/home/logo-mobile.png" /></a>
    </div>
    <a class="menu-icon block xl:hidden" @click="handleclick">

        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="11px" viewBox="0 0 20 11" style="enable-background:new 0 0 20 11;" xml:space="preserve">

            <rect class="menu-svg" width="20" height="1" />
            <rect y="5" class="menu-svg" width="20" height="1" />
            <rect y="10" class="menu-svg" width="20" height="1" />
        </svg>

    </a>
</nav>

</template>

<script>

import {
    mapGetters
}
from 'vuex'
import NavBarLink from '@/components/NavBarLink.vue'
export default {
    name: 'NavBar',
    components: {
        NavBarLink
    },

    data() {
        return {
            menuIsOpen: false

        }
    },
    methods: {
        handleclick() {
            this.menuIsOpen = !this.menuIsOpen
        }
    },


    computed: {
        ...mapGetters([
            'canSelectConfigure',
            'canSelectYourDesign'
        ])
    }
}

</script>
